import { Sex as SexZod } from '../fetching/sharedSchemas/basicSchemas';

export enum Sex {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    INTERSEX = 'INTERSEX',
    UNKNOWN = 'UNKNOWN',
}

export const renderSex = (sex: Sex): string => {
    switch (sex) {
        case Sex.MALE:
            return 'Male';
        case Sex.FEMALE:
            return 'Female';
        case Sex.INTERSEX:
            return 'Intersex';
        case Sex.UNKNOWN:
            return 'Unknown';
        default:
            throw new Error(`Unknown sex: ${sex as string}`);
    }
};

// Temp: conversion between graphql and zod types
export const sexToCode = (sex: Sex): string => {
    switch (sex) {
        case Sex.MALE:
            return 'M';
        case Sex.FEMALE:
            return 'F';
        case Sex.INTERSEX:
            return 'I';
        case Sex.UNKNOWN:
            return 'U';
        default:
            throw new Error(`Unknown sex: ${sex as string}`);
    }
};
export const codeToSex = (code: string): Sex => {
    switch (code) {
        case 'M':
            return Sex.MALE;
        case 'F':
            return Sex.FEMALE;
        case 'I':
            return Sex.INTERSEX;
        case 'U':
            return Sex.UNKNOWN;
        default:
            throw new Error(`Unknown sex code: ${code}`);
    }
};

// Temp: conversion between graphql and zod types
export const sexToZod = (sex: Sex): SexZod => {
    return { code: sexToCode(sex), name: renderSex(sex) };
};

export const availableSexes = Object.values(Sex).map(sexToZod);
